define('RecipesAndEvents.View', [
    'Backbone',
    'recipes_and_events.tpl',
    'SC.Configuration',
    'underscore'
], function RecipesAndEventsView(
    Backbone,
    recipesAndEventsTpl,
    Configuration,
    _
) {
    'use strict';

    var TYPES = ['Item', 'Events', 'Recipe'];

    return Backbone.View.extend({
        template: recipesAndEventsTpl,
        initialize: function initialize(options) {
            this.application = options.application;
            this.translatorConfig = this.application.translatorConfig;
            this.url = Backbone.history.fragment;
            this.isExcludedCat = this.options.isExcludedCat;
            this.searchRedirect();
        },
        searchRedirect: function searchRedirect() {
            if (this.url && this.url === 'search') {
                Backbone.history.navigate(this.url + '?custitem_item_type=Item', { trigger: true, replace: true });
            } else if (this.url && this.url.indexOf('search?') >= 0 && this.url.indexOf('custitem_item_type') === -1) {
                Backbone.history.navigate(this.url + '&custitem_item_type=Item', { trigger: true, replace: true });
            }
        },
        removeURLParameter: function removeURLParameter(url, parameter) {
            var urlparts = url.split('?');
            if (urlparts.length >= 2) {
                var prefix = encodeURIComponent(parameter) + '=';
                var pars = urlparts[1].split(/[&;]/g);
                for (var i = pars.length; i-- > 0;) {
                    if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                        pars.splice(i, 1);
                    }
                }
                return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
            }
            return url;
        },
        getUrl: function getUrl(type) {
            var url = this.url;
            var urlArray;
            var urlType;
            var replace = true;
            var isSearch = url.indexOf('search') >= 0;
            if (isSearch) {
                if (url.indexOf('custitem_item_type') === -1) {
                    if (url.indexOf('?') >= 0) {
                        url = url + '&custitem_item_type=' + type;
                    } else {
                        url = url + '?custitem_item_type=' + type;
                    }
                } else if (url.indexOf('custitem_item_type=') > -1) {
                    _.each(TYPES, function eachType(t) {
                        if (replace && url.indexOf('custitem_item_type=' + t) > -1) {
                            url = url.replace('custitem_item_type=' + t, 'custitem_item_type=' + type);
                            replace = false;
                        }
                    });
                }
            } else if (url.indexOf('?') >= 0) {
                if (url.indexOf('custitem_item_type') === -1) {
                    url = url.replace('?', '/custitem_item_type/' + type + '?');
                } else {
                    _.each(TYPES, function eachType(t) {
                        if (replace && url.indexOf('/' + t) > -1) {
                            url = url.replace('/' + t, '/' + type);
                            replace = false;
                        }
                    });
                }
                if (url.indexOf('page=') >= 0) {
                    url = this.removeURLParameter(url, 'page');
                }
            } else if (url.indexOf('custitem_item_type') === -1) {
                url = url + '/custitem_item_type/' + type;
            } else if (url.indexOf('custitem_item_type=') > -1) {
                _.each(TYPES, function eachType(t) {
                    if (replace && url.indexOf('custitem_item_type=' + t) > -1) {
                        url = url.replace('custitem_item_type=' + t, 'custitem_item_type=' + type);
                        replace = false;
                    }
                });
            } else if (url.indexOf('custitem_item_type/') > -1) {
                urlArray = url.split('/');
                if (urlArray && urlArray.length > urlArray.indexOf('custitem_item_type') + 1 && urlArray[urlArray.indexOf('custitem_item_type') + 1]) {
                    urlType = urlArray[urlArray.indexOf('custitem_item_type') + 1];
                    url = url.replace(urlType, type);
                }
            }

            return url;
        },
        getContext: function getContext() {
            this.articleActive = this.url.indexOf('custitem_item_type=Events') > -1 || this.url.indexOf('custitem_item_type/Events') > -1;
            this.recipesActive = this.url.indexOf('custitem_item_type=Recipe') > -1 || this.url.indexOf('custitem_item_type/Recipe') > -1;
            this.itemActive = this.url.indexOf('custitem_item_type=Item') > -1 || this.url.indexOf('custitem_item_type/Item') > -1
                || this.url.indexOf('custitem_item_type') === -1;
            return {
                itemActive: this.itemActive ? 'active' : '',
                articleActive: this.articleActive ? 'active' : '',
                recipesActive: this.recipesActive ? 'active' : '',
                itemUrl: this.getUrl('Item'),
                articleUrl: this.getUrl('Events'),
                recipesUrl: this.getUrl('Recipe'),
                showEvents: !Configuration.get('recipesAndEvents.eventsInactive'),
                showRecipes: !Configuration.get('recipesAndEvents.recipesInactive'),
                show: !this.isExcludedCat
            };
        }
    });
});
